import { render, staticRenderFns } from "./DropzoneFile.vue?vue&type=template&id=608403a3&scoped=true"
import script from "./DropzoneFile.vue?vue&type=script&lang=js"
export * from "./DropzoneFile.vue?vue&type=script&lang=js"
import style0 from "./DropzoneFile.vue?vue&type=style&index=0&id=608403a3&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "608403a3",
  null
  
)

export default component.exports